export interface AdministratorUserApiModel {
  id: number;
  personId: number;
  inviteCode?: string;
  email: string;
  invitationEmail: string;
  name: string;
  accessType: string;
  role: string;
  accountRole: AdministratorRoleApiModel | null;
  dealRoles: AdministratorRoleApiModel[];
  acceptedDate?: Date | null;
  invitedByPersonName: string;
  phone?: Admin2FAPhoneNumberModel;
  phoneNumber?: string;
  action?: UserAction;
  lastLoggedIn?: string;
  inviteStatus?: string;
}

export interface UserAction {
  editable: boolean;
  deletable: boolean;
}

export interface AdministratorRoleApiModel {
  roleId: string;
  roleName: string;
  dealId?: string;
}

export interface Admin2FAPhoneNumberModel {
  countryCodeId?: string;
  countryCode?: string;
  number?: string;
}
export type BaseAdmin = Pick<
  AdministratorUserApiModel,
  | 'email'
  | 'invitationEmail'
  | 'inviteCode'
  | 'phone'
  | 'phoneNumber'
  | 'inviteStatus'
> & {
  id?: number;
  personId?: number;
  adminId?: number;
  accountRole: string | null;
  isOwnAccount?: boolean;
  role?: string | null;
};

export type ModifyAdminFunc = (admin: BaseAdmin | undefined) => void;

export interface AdminActions {
  onEdit?: ModifyAdminFunc;
  onRemove?: ModifyAdminFunc;
  removableAdmin: BaseAdmin | undefined;
}

export const emptyUser: BaseAdmin = {
  email: '',
  invitationEmail: '',
  accountRole: 'B2B:ADM',
};
